import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-chronicpain',
  templateUrl: './chronicpain.component.html',
  styleUrls: ['./chronicpain.component.scss']
})
export class ChronicpainComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  btnBackClick = function () {
    this.router.navigateByUrl('/conditions')
  }
}
